"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CASDOOR_SDK_INJECTION_KEY = void 0;

var _casdoorJsSdk = _interopRequireDefault(require("casdoor-js-sdk"));

var CASDOOR_SDK_TOKEN = '$casdoor-sdk';
/**
 * @summary  Injection token used to `provide` / `inject` the `Sdk` instance.
 * @type { import('vue').InjectionKey<Sdk> }
 */

var CASDOOR_SDK_INJECTION_KEY = Symbol["for"](CASDOOR_SDK_TOKEN);
exports.CASDOOR_SDK_INJECTION_KEY = CASDOOR_SDK_INJECTION_KEY;


//////////////////
// WEBPACK FOOTER
// ./node_modules/casdoor-vue-sdk/src/token.js
// module id = fPmm
// module chunks = 9